import { z } from 'zod';

export const matryoshkaSchema = z.enum([
  'личность',
  'экспертность',
  'проблема_боль',
  'метод_решение',
  'продукт',
]);

export type Matryoshka = z.infer<typeof matryoshkaSchema>;
